import {useMemo} from "react";
import {ReferencesBlock} from "./ReferencesBlock";
import {isFilteredContentish, isReferenceNode} from "../../../../../types";
import {FilteredContentWarning} from "../../error-handling/FilteredContentWarning";
import {ChartBlock, isChartNode} from "./ChartBlock";

export function renderNode(json: unknown) {
    if (isReferenceNode(json)) {
        if (Array.isArray(json)) {
            return <ReferencesBlock items={json[0]} />;
        } else {
            return <ReferencesBlock items={json} />;
        }
    }

    if (isFilteredContentish(json)) {
        return <FilteredContentWarning />;
    }

    const chart = isChartNode(json);
    if (chart) {
        return <ChartBlock chart={chart} />;
    }

    return null;
}

type CodeBlockProps = {
    children: string;
    node: {
        type: "element";
        tagName: "code";
        properties: unknown;
        position: {
            start: {line: number; column: number; offset: number};
            end: {line: number; column: number; offset: number};
        };
        children: {type: "text"; value: string}[];
    };
};

export const CodeBlock = ({children}: CodeBlockProps) => {
    const rendered = useMemo(() => {
        try {
            /* const json = JSON.parse(children); */

            return renderNode(children);
        } catch (e) {
            // console.error("Failed to parse JSON", children, e);
            // Perhaps incomplete JSON, so just render loading

            console.log("Failed to render Node", children);
            return null;

            /* return (
                <div>
                    <Loader
                        className={classes.loader}
                        type="dots"
                        color="black"
                    />
                </div>
            ); */
        }
    }, [children]);

    return rendered;
};
